import { graphql } from '@/client/services/api/graphql/gql/gql';

export const bulkUserSearchFromEmailsQuery: any = graphql(`
  query BulkUserSearchFromEmail($userEmails: [String!]!) {
    bulkUserSearch(userEmails: $userEmails) {
      users {
        id
        fullName
        image
        __typename
      }
    }
  }
`);
